export const AppPopups = () => {
  return <>{null}</>;
};

export default AppPopups;
